export default __webpack_public_path__ + "static/media/assets.743fedaa.zip";